import { render, staticRenderFns } from "./CsSkeleton.vue?vue&type=template&id=2acf426e&"
import script from "./CsSkeleton.vue?vue&type=script&lang=js&"
export * from "./CsSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports